/**
 * Email paste area, Parse action, and invalid/duplicate parse feedback for Create Administrators.
 */

import { observer } from 'mobx-react-lite';

import Card from '../../../../../components/layouts/card/card';
import { Button } from '../../../../../components/inputs/button/button';
import { Textarea } from '../../../../../components/inputs/textarea/textarea';
import { BUTTON_VARIANTS } from '../../../../../components/inputs/button-variants';
import FontHeading4 from '../../../../../components/fonts/font-heading4/font-heading4';
import FontHeading5 from '../../../../../components/fonts/font-heading5/font-heading5';
import createAdministratorsStore from '../stores/create-administrators-store';
import CreateAdministratorsParseFeedback from './create-administrators-parse-feedback';

const CreateAdministratorsEmailParseCard: React.FC = observer(() => {
    const store = createAdministratorsStore;

    return (
        <Card isExpandable={false}>
            <FontHeading4>Create Administrators</FontHeading4>
            <FontHeading5>Paste emails (comma-separated)</FontHeading5>
            <div className="create-administrators-page__textarea-wrapper">
                <Textarea
                    value={store.emailInput}
                    onChange={(value) => store.setEmailInput(value)}
                    placeholder="jon.doe.smith@example.com, jane@example.com"
                />
            </div>
            <div className="troubleshooting-buttons-container">
                <Button
                    text="Parse emails"
                    variant={BUTTON_VARIANTS.Primary}
                    onClick={() => store.parseEmails()}
                    disabled={store.isSubmitting}
                />
            </div>
            <CreateAdministratorsParseFeedback
                invalidParseEntries={store.invalidParseEntries}
                duplicateParseEntries={store.duplicateParseEntries}
            />
        </Card>
    );
});
export default CreateAdministratorsEmailParseCard;
